import React, { Fragment, useEffect, useState } from 'react'
// Components
import Form from 'common/components/form/new-form'
import { SideModal, SideModalButtons, SideModalInner } from 'components/modal'
// Routes
// import { choosePlan } from 'config/routes';
// Modules
import { DI } from 'modules'
import Loading from 'components/page-loading'
import Agreement from './agreement/agreement'
import {
  Button,
  Hints,
  RequestPlan,
  Sftp,
  FreeAccess,
  ChoosePlan,
  Contacts,
  WorldExclusiveBtn,
} from './common'
// Constants
import { AGREEMENT_TYPE, DOWNLOAD_TYPE } from './constants'
// Hooks
import { useDownloadSlider } from './download-slider.hooks'
import { DateTime } from 'luxon'
import useAnalytics from 'hooks/use-analytics'

const SliderBody = props => {
  const {
    currentAgreement,
    form,
    handleFormChange,
    handleFormSubmit,
    handleSftpClose,
    handleSftpSuccess,
    handleUpdateFormState,
    hints,
    isScreener,
    price,
    sftpIsOpened,
    isRepeated,
    activeAgreements,
    inactiveAgreements,
    modifyAgrList,
  } = useDownloadSlider(props)

  const {
    buttonProps,
    entity,
    innerComponent: Inner,
    innerProps,
    user,
    common: { strings },
    buttonText,
    contentType,
    languageId,
  } = props

  const { trackClick } = useAnalytics({
    groupEvent: 'ACTION_LIVE',
    clickType:
      contentType === 'live'
        ? 'click_book_live_plan'
        : 'click_download_video_plan',
    trackData: {
      location: {
        page_layout: contentType === 'live' ? 'live_page' : 'video_page',
        list: 'none',
      },
    },
  })

  const { payload: currentUser } = user.currentUser
  const isRequestOnly =
    DateTime.fromISO(entity.published_at) <=
    DateTime.fromISO(process.env.REQUEST_ONLY_DATE)

  const {
    can: canDownload,
    limit_type,
    why_not_reason,
    download_type,
  } = currentAgreement?.can_download_content || {}
  const onRequest =
    isRequestOnly || (!canDownload && why_not_reason === 'on_request')
  const isOneOff = download_type === AGREEMENT_TYPE.ONE_OFF || !currentAgreement

  const isExclusive =
    isRequestOnly || currentAgreement
      ? entity.exclusive && !isOneOff
      : entity.exclusive
  const isPool = entity.limit_type === 'pool'
  const prefix = 'page.video.slider'
  const isFree = download_type === DOWNLOAD_TYPE.FREE
  const worldExclusiveReq =
    isRequestOnly || (entity.world_exclusive && onRequest)
  const exclusiveReq = isRequestOnly || (isExclusive && onRequest)
  const noActiveAgrs = inactiveAgreements.length === modifyAgrList.length

  useEffect(() => {
    if (contentType === 'live') {
      trackClick(
        {
          id: entity.slug,
          plan: currentAgreement.id,
          live_language_id: languageId,
        },
        'click_book_live_plan'
      )
    }
  }, [currentAgreement])

  return (
    <Fragment>
      {sftpIsOpened && (
        <Sftp
          company={currentUser.company}
          onClose={handleSftpClose}
          onSuccess={handleSftpSuccess}
        />
      )}

      <Form onChange={handleFormChange} onSubmit={handleFormSubmit}>
        <input name="agreement_id" type="hidden" value={form.agreement_id} />
        <input name="branding_type" type="hidden" value={form.branding_type} />

        <SideModalInner style={{ paddingBottom: 200 }}>
          {(exclusiveReq || worldExclusiveReq || noActiveAgrs) && (
            <div className="side-buy-plan">
              <div className="side-buy-plan__text">
                {strings[`${prefix}.world_exclusive.content_restricted_msg_1`]}

                <a
                  className="text-button"
                  href={`mailto:${strings['clientdesk.email']}`}
                >
                  {strings['clientdesk.email']}
                </a>
                {strings[`${prefix}.world_exclusive.content_restricted_msg_2`]}
              </div>
            </div>
          )}

          {user.haveUnacceptedAgreements &&
            currentUser.user_group === 'client' && (
              <div className="side-buy-plan__text">
                {strings[`${prefix}.have_unaccepted_agreements`]}
              </div>
            )}

          {isPool && isOneOff ? (
            <div className="side-buy-plan__text">
              {
                strings[
                  `${prefix}.one_off.pool${
                    why_not_reason === 'limit' ? '.reached' : ''
                  }`
                ]
              }
            </div>
          ) : (
            <div className="side-buy-plans">
              {isFree && <FreeAccess />}
              {!(
                (modifyAgrList.length <= 1 && entity.free_access) ||
                exclusiveReq
              ) &&
                !onRequest &&
                !noActiveAgrs &&
                modifyAgrList.map(item => (
                  <Agreement
                    key={item.id}
                    agreement={item}
                    entity={entity}
                    form={form}
                    isRepeated={isRepeated}
                    multiple={modifyAgrList.length > 1}
                    price={price}
                  />
                ))}
            </div>
          )}

          {!isRequestOnly &&
            ((!activeAgreements.length &&
              !(entity.world_exclusive || exclusiveReq)) ||
              limit_type !== 'none') && (
              <>
                {isPool && isOneOff ? (
                  <ChoosePlan />
                ) : (
                  !exclusiveReq && <Contacts />
                )}
              </>
            )}

          {!isRequestOnly && canDownload && (
            <>
              {Inner && (
                <Inner
                  {...innerProps}
                  agreement={currentAgreement}
                  entity={entity}
                  form={form}
                  updateForm={handleUpdateFormState}
                />
              )}

              {modifyAgrList.length === 1 &&
                isOneOff &&
                !entity.free_access && <ChoosePlan />}

              {modifyAgrList.length === 1 &&
                currentAgreement.agreement_type === AGREEMENT_TYPE.PASS && (
                  <RequestPlan />
                )}
            </>
          )}
        </SideModalInner>

        {onRequest
          ? (worldExclusiveReq || isExclusive) && (
              <WorldExclusiveBtn id={entity.inner_id} onClose={props.onClose} />
            )
          : canDownload && (
              <SideModalButtons>
                <Hints
                  agreement={currentAgreement}
                  hints={hints}
                  isRepeated={isRepeated}
                />
                {isOneOff && (
                  <div className="side-buy-plan__text">
                    {strings['page.video.slider.payment_method_unavailable_1']}{' '}
                    <a
                      className="text-button"
                      href={
                        'mailto:' +
                        strings[
                          'page.plan_details.agreements.contact_info.email'
                        ]
                      }
                    >
                      {
                        strings[
                          'page.plan_details.agreements.contact_info.email'
                        ]
                      }
                    </a>
                    .{' '}
                    {strings['page.video.slider.payment_method_unavailable_2']}
                  </div>
                )}
                <Button
                  {...buttonProps}
                  agreement={currentAgreement}
                  disabled={!!hints.length}
                  entity={entity}
                  isRepeated={isRepeated}
                  price={price}
                  screener={isScreener}
                  user={currentUser}
                >
                  {buttonText}
                </Button>
              </SideModalButtons>
            )}
      </Form>
    </Fragment>
  )
}

const DownloadSlider = props => {
  const [isLoading, setLoading] = useState(true)
  const {
    onClose,
    user: { agreements, activeAgreements },
    contentType,
    contentId,
  } = props

  useEffect(() => {
    if (contentType && contentId) {
      loadAgreements(contentId, contentType)
    }
  }, [contentId])

  const loadAgreements = async (id, type) => {
    setLoading(true)
    try {
      await props.actions.user.getAgreements()
      await props.actions.user.getActiveAgreements({
        content_id: id,
        content_type: type,
      })
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const isPending = agreements.pending || activeAgreements.pending

  return (
    <SideModal onClose={onClose}>
      {isLoading || isPending ? (
        <SideModalInner style={{ padding: 0, height: '100%' }}>
          <Loading />
        </SideModalInner>
      ) : (
        <SliderBody {...props}></SliderBody>
      )}
    </SideModal>
  )
}

export default DI(['user'])(DownloadSlider)
